import React, { useState, useEffect } from 'react';
import { pagesAPI } from '../services/api';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PoliticaCancelamento = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const data = await pagesAPI.getByName('termo-adesao');
      if (data && data.content) {
        setContent(data.content);
      }
    } catch (error) {
      console.error('Erro ao carregar termo:', error);
    } finally {
      setLoading(false);
    }
  };

  // Conteúdo padrão caso não haja conteúdo salvo
  const defaultContent = `
    <h1>TERMO DE ADESÃO E CONDIÇÕES GERAIS DE VIAGEM</h1>
    <h2>TÔ INDO ALI – TURISMO E AVENTURA</h2>
    
    <p>A TÔ INDO ALI – Turismo e Aventura, pessoa jurídica de direito privado, inscrita no CNPJ nº 46.231.427/0001-00, com Cadastur ativo junto ao Ministério do Turismo, sediada em Duque de Caxias/RJ, doravante denominada AGÊNCIA, estabelece neste instrumento os Termos de Adesão e Condições Gerais, aplicáveis a todos os serviços turísticos comercializados em seu site e canais oficiais.</p>
    
    <p><strong>A contratação de qualquer pacote, passeio ou viagem implica leitura, ciência e aceitação integral deste Termo.</strong></p>

    <h3>1. MODALIDADE DAS VIAGENS</h3>
    <p>As viagens e passeios são comercializados, em regra, na modalidade GRUPO ABERTO, composta por participantes que não possuem vínculo prévio entre si.</p>
    <p>A realização das viagens poderá estar condicionada à formação de número mínimo de participantes, conforme informado no material do pacote e no contrato específico.</p>

    <h3>2. TIPOS DE SERVIÇOS OFERECIDOS</h3>
    <p>A AGÊNCIA comercializa e/ou opera:</p>
    <ul>
      <li>Viagens rodoviárias nacionais</li>
      <li>Viagens aéreas nacionais</li>
      <li>Viagens internacionais</li>
      <li>Passeios de 1 dia</li>
    </ul>
    <p>Cada modalidade possui contrato específico, que complementa este Termo.</p>

    <h3>3. PAPEL DA AGÊNCIA</h3>
    <p>A AGÊNCIA atua como organizadora, coordenadora e intermediadora de serviços turísticos, podendo envolver terceiros, tais como:</p>
    <ul>
      <li>Transportadoras rodoviárias</li>
      <li>Companhias aéreas</li>
      <li>Meios de hospedagem</li>
      <li>Operadores locais e guias</li>
    </ul>
    <p>A AGÊNCIA não se confunde com transportadora aérea ou rodoviária, não respondendo por atos exclusivos desses prestadores, nos limites da legislação aplicável.</p>

    <h3>4. SERVIÇOS INCLUSOS E NÃO INCLUSOS</h3>
    <p>Os serviços inclusos são exclusivamente aqueles descritos na página do pacote no momento da contratação.</p>
    <p>Salvo indicação expressa, não estão inclusos:</p>
    <ul>
      <li>Alimentação não mencionada</li>
      <li>Despesas pessoais</li>
      <li>Bebidas, extras e gorjetas</li>
      <li>Taxas locais</li>
      <li>Documentação, vistos, vacinas e exames</li>
      <li>Despesas médicas e seguro viagem</li>
    </ul>

    <h3>5. PAGAMENTO E INADIMPLÊNCIA</h3>
    <p>O pagamento deverá ser realizado conforme condições escolhidas no ato da compra.</p>
    <p>O atraso no pagamento poderá acarretar:</p>
    <ul>
      <li>Multa moratória de 2%</li>
      <li>Juros de 1% ao mês</li>
    </ul>
    <p>O atraso superior a 15 dias autoriza o cancelamento da vaga, aplicando-se a política de cancelamento.</p>

    <h3>6. POLÍTICA DE CANCELAMENTO</h3>
    <p>A política de cancelamento varia conforme a modalidade da viagem, considerando compromissos assumidos com fornecedores.</p>
    
    <h4>6.1 Viagens Rodoviárias Nacionais</h4>
    <ul>
      <li>Até 31 dias antes: devolução de 90%, descontada taxa de reserva</li>
      <li>Entre 30 e 21 dias: devolução de 80%, descontada taxa de reserva</li>
      <li>Menos de 21 dias ou no-show: sem reembolso</li>
    </ul>

    <h4>6.2 Viagens Aéreas Nacionais e Internacionais</h4>
    <ul>
      <li>Taxa administrativa fixa: R$ 300,00</li>
      <li>Mais de 60 dias: retenção de 20%</li>
      <li>59 a 40 dias: retenção de 30%</li>
      <li>39 a 25 dias: retenção de 40%</li>
      <li>24 a 11 dias: retenção de 60%</li>
      <li>10 dias ou menos, no-show ou abandono: retenção de 100%</li>
    </ul>

    <h4>6.3 Passeios de 1 Dia</h4>
    <ul>
      <li>Cancelamento com até 7 dias: possibilidade de crédito, quando viável</li>
      <li>Cancelamento com menos de 7 dias ou no-show: sem reembolso</li>
    </ul>

    <h3>7. ALTERAÇÕES E CANCELAMENTOS POR PARTE DA AGÊNCIA</h3>
    <p>A AGÊNCIA poderá cancelar ou alterar a operação em casos de:</p>
    <ul>
      <li>Não atingimento do número mínimo</li>
      <li>Questões operacionais</li>
      <li>Determinação de autoridades</li>
      <li>Caso fortuito ou força maior</li>
    </ul>
    <p>Nessas hipóteses, o cliente poderá optar por:</p>
    <ul>
      <li>Reembolso integral, ou</li>
      <li>Crédito para uso futuro</li>
    </ul>

    <h3>8. LOGÍSTICA AÉREA</h3>
    <p>Em viagens aéreas, poderão ocorrer ajustes de até 3 dias antes ou depois da data inicialmente prevista, mantendo-se a duração total da viagem, especialmente em razão de bloqueios e tarifas de grupo.</p>
    <p>Alterações, atrasos ou cancelamentos de voos são de responsabilidade exclusiva das companhias aéreas, conforme Resolução ANAC nº 400/2016.</p>

    <h3>9. CONDUTA E SEGURANÇA</h3>
    <p>É expressamente vedado:</p>
    <ul>
      <li>Porte, uso ou comercialização de armas e/ou substâncias ilícitas</li>
      <li>Condutas que coloquem em risco o grupo ou terceiros</li>
      <li>Descumprimento de leis locais ou orientações da coordenação</li>
    </ul>
    <p>A violação poderá resultar em exclusão imediata, sem direito a reembolso.</p>

    <h3>10. CIÊNCIA DE RISCOS</h3>
    <p>O cliente declara ciência de que atividades turísticas envolvem riscos inerentes, assumindo responsabilidade por sua condição física, saúde e decisões pessoais durante a viagem.</p>

    <h3>11. USO DE IMAGEM</h3>
    <p>O cliente autoriza, de forma gratuita, o uso de sua imagem, voz e nome captados durante a viagem para fins institucionais e promocionais da AGÊNCIA, salvo manifestação expressa em contrário.</p>

    <h3>12. ACEITAÇÃO ELETRÔNICA</h3>
    <p>Este Termo é considerado aceito:</p>
    <ul>
      <li>No ato da contratação pelo site, ou</li>
      <li>Na confirmação do primeiro pagamento</li>
    </ul>
    <p>Integrando automaticamente o contrato correspondente à modalidade adquirida.</p>

    <h3>13. FORO</h3>
    <p>Fica assegurado ao consumidor o foro de seu domicílio, nos termos do art. 101, inciso I, do Código de Defesa do Consumidor.</p>
  `;

  const htmlContent = content?.htmlContent || defaultContent;

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Breadcrumb */}
        <div className="mb-6">
          <Link to="/" className="inline-flex items-center text-[#003366] hover:text-[#002244] transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar para o início
          </Link>
        </div>

        {/* Content Card */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-10">
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#003366]"></div>
            </div>
          ) : (
            <div 
              className="prose prose-lg max-w-none termo-content"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          )}
        </div>

        {/* Footer Info */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <p>TÔ INDO ALI – Turismo e Aventura</p>
          <p>CNPJ: 46.231.427/0001-00 | Cadastur Ativo</p>
        </div>
      </div>

      {/* Estilos iguais aos contratos */}
      <style>{`
        .termo-content h1 { 
          font-size: 1.5rem; 
          font-weight: bold; 
          text-align: center; 
          margin-bottom: 0.5rem; 
          color: #1a1a1a;
        }
        .termo-content h2 { 
          font-size: 1.1rem; 
          text-align: center; 
          color: #666; 
          margin-bottom: 1.5rem; 
          font-weight: 600;
        }
        .termo-content h3 { 
          font-size: 1rem; 
          font-weight: bold; 
          margin-top: 1.5rem; 
          margin-bottom: 0.5rem; 
          color: #003366;
          border-bottom: 1px solid #e5e7eb;
          padding-bottom: 0.25rem;
        }
        .termo-content h4 { 
          font-size: 0.95rem; 
          font-weight: 600; 
          margin-top: 1rem; 
          margin-bottom: 0.25rem; 
          color: #003366;
        }
        .termo-content ul { 
          margin-left: 1.5rem; 
          list-style-type: disc; 
          font-size: 0.95rem; 
          margin-bottom: 1rem;
        }
        .termo-content li { 
          margin-bottom: 0.25rem; 
          color: #374151;
        }
        .termo-content p { 
          font-size: 0.95rem; 
          margin-bottom: 0.75rem; 
          color: #374151;
          line-height: 1.6;
        }
        .termo-content strong {
          color: #1a1a1a;
        }
      `}</style>
    </div>
  );
};

export default PoliticaCancelamento;
